import styles from './UnauthorisedTagsAlert.module.css'

// What the API reports when a workspace has scanned tags another workspace
// owns (printed them, else used them first): GET /api/dashboard and God
// Mode's client detail, as unauthorised_tag_use.
export interface UnauthorisedTagUse {
  count: number
  since: string | null
  codes: { code: string; label: string }[]
  message?: string
}

export const UNAUTHORISED_TAGS_MESSAGE =
  'Unauthorised tag(s) used, breaches terms of service - contact support@dataphyll.com to apply for co-mingling module, failure to do so will mean that the data will be deleted'

export function UnauthorisedTagsAlert({ use }: { use: UnauthorisedTagUse | null | undefined }) {
  if (!use || !use.count) return null
  const shown = use.codes.map((c) => c.label || c.code)
  const more = use.count - shown.length
  return (
    <div className={styles.alert} role="alert" data-testid="unauthorised-tags">
      <p className={styles.message}>{use.message || UNAUTHORISED_TAGS_MESSAGE}</p>
      <p className={styles.detail}>
        {use.count === 1 ? '1 tag' : `${use.count} tags`}
        {use.since ? ` since ${new Date(use.since).toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' })}` : ''}:{' '}
        <span className={styles.codes}>
          {shown.join(', ')}
          {more > 0 ? ` and ${more} more` : ''}
        </span>
      </p>
    </div>
  )
}
